<template>
  <div v-if="activeX">
    <popup
      :active.sync="activeX" :title="`Акт${actData.id ? ` #${actData.id}` : ''}`" :width="popupStyles.popupWidth"
      class="act-info"
    >
      <transition-group name="fade" mode="out-in">
        <template v-if="!isLoading">
          <div key="act-info__files" :style="{width: popupStyles.sidebarWidth}" class="act-info__files">
            <div class="act-info__section-header act-info__section-header_flex relative">
              <div :class="{'text-danger': filesEmptyError}">Файлы</div>
              <div class="act-viewer-switch">
                <label class="act-viewer-switch__label">Просмотр</label>
                <vs-switch
                  class="ml-2 vs-switch_small act-viewer-switch__sswitch" v-model="showImagesViewer"
                  ref="toggleShowInactiveDevices"
                />
              </div>
              <transition name="fade">
                <div class="file-empty-error validation-input-error" v-if="filesEmptyError">
                  Для данного типа акта необходимо загрузить хотя бы один файл
                </div>
              </transition>
            </div>
            <div class="act-info__section-body">
              <swiper :options="swiperOption" class="h-full">
                <swiper-slide v-if="canActEdit">
                  <div class="act-info__file act-info__file_upload act-file-uploader">
                    <feather-icon icon="UploadCloudIcon" class="act-info__file-icon" />
                    <div class="act-info__file-ext">Добавить файл</div>

                    <input
                      type="file" multiple class="act-file-uploader__input" @change="handleFileUploads"
                      ref="files"
                    />
                  </div>
                </swiper-slide>
                <swiper-slide v-for="(file, fileIndex) in actData.files.uploaded" :key="`uploaded-${fileIndex}`">
                  <uploaded-file-block
                    :file="file" @delete-file="deleteFile('uploaded',fileIndex)"
                    :canDelete="canActEdit"
                  />
                </swiper-slide>
                <swiper-slide v-for="(file, fileIndex) in actData.files.fromStorage" :key="`fromStorage-${fileIndex}`">
                  <uploaded-file-block
                    :file="file" @delete-file="deleteFile('fromStorage',fileIndex)"
                    :canDelete="canActEdit"
                  />
                </swiper-slide>
              </swiper>
            </div>
            <transition name="fade" mode="out-in" :duration="300">
              <div
                class="act-info__files-viewer" ref="imagesViewer" :style="{width: 'calc(100% - 260px)'}"
                v-if="showImagesViewer"
              >
                <transition name="fade" mode="out-in">
                  <div class="w-full h-full" v-if="!!viewImages.length && !viewerHidden">
                    <viewer
                      :options="{inline: true}" :images="viewImages"
                      class="viewer" ref="viewer"
                      @inited="inited"
                    >
                      <template slot-scope="scope">
                        <img
                          class="image hidden"
                          :src="image" :data-source="image" v-for="(image, imageIndex) in scope.images"
                          :key="imageIndex"
                        />
                      </template>
                    </viewer>
                  </div>

                  <div class="no-images-to-view" v-else-if="!viewImages.length">
                    Добавьте изображения для просмотра
                  </div>
                </transition>

              </div>
            </transition>
          </div>
          <div key="act-info__main-info" class="act-info__main-info" :style="{marginLeft: popupStyles.contentMargin}">
            <div class="vx-row">
              <div class="vx-col w-full flex items-center justify-between">
                <div>
                  <act-status :id="actData.main.status" />
                </div>
                <div class="act-header-buttons">
                  <vs-button
                    title="Сохранить" icon-pack="feather" icon="icon-save"
                    class="act-header-button act-header-button_icon" type="border" @click="saveAct(false)"
                    v-if="canActEdit"
                  />
                  <vs-button
                    title="Применить" icon-pack="feather" icon="icon-check"
                    class="act-header-button act-header-button_icon" type="border" color="success"
                    v-if="canActEdit && actData.id" @click="saveAct(true)"
                  />
                  <vs-button
                    title="История" icon-pack="feather" icon="icon-clock"
                    class="act-header-button act-header-button_icon" type="border" color="warning"
                    v-if="actData.id && false"
                  />
                  <vs-button
                    title="Удалить" icon-pack="feather" icon="icon-trash"
                    class="act-header-button act-header-button_icon" type="border" color="danger"
                    v-if="canActEdit && actData.id" @click="deleteAct(false)"
                  />
                  <vs-button
                    title="Изменить" icon-pack="feather" icon="icon-edit"
                    class="act-header-button act-header-button_icon" type="border" color="primary"
                    v-if="actData.main.status === 4 && $can('rp.acts.update', 'write') && actData.id"
                    @click="deleteAct(true)"
                  />
                  <vs-button
                    title="Отменить" icon-pack="feather" icon="icon-trash"
                    class="act-header-button act-header-button_icon" type="border" color="danger"
                    v-if="actData.main.status === 4 && $can('rp.acts.update', 'write') && actData.id"
                    @click="deleteAct(false)"
                  />
                </div>
              </div>
            </div>

            <div class="vx-row" v-if="actData.main.status === 7 && actData.main.errors !== null">
              <div class="vx-col mt-2">
                <ul>
                  <li v-for="(error, errorIndex) in actData.main.errors" :key="errorIndex" class="text-danger">
                    {{ error }}
                  </li>
                </ul>
              </div>

            </div>

            <vs-divider><span class="font-medium">ОСНОВНОЕ</span></vs-divider>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="act-info__param-row">
                  <label class="act-info__param-label">Тип</label>
                  <div class="act-info__param-form-control">
                    <elsa-v-select
                      :options="localActTypes"
                      v-model="actData.main.act_type"
                      label="name"
                      :reduce="item => item.id"
                      :clearable="false"
                      :disabled="!canActEdit || !!actData.id"
                      :danger="$v['actData.main'].act_type.$error"
                      danger-text="Выберите тип"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="act-info__param-row">
                  <label class="act-info__param-label">Дом</label>
                  <div class="act-info__param-form-control">
                    <elsa-v-select
                      :options="buildings"
                      v-model="actData.main.buildings_id"
                      label="address"
                      :reduce="item => item.id"
                      :clearable="false"
                      :disabled="!canActEdit"
                      :danger="$v['actData.main'].buildings_id.$error"
                      danger-text="Выберите дом"
                      @input="setBuilding($event)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <template v-if="!canActEdit">
              <vs-divider><span class="font-medium">ПРИКРЕПЛЕН К</span></vs-divider>

              <div class="vx-row">
                <div class="vs-col w-full">
                  <div v-for="(obj, objIndex) in actData.objects" :key="objIndex" class="attached-object-row">
                    <feather-icon
                      v-if="obj.icon" :icon="obj.icon" class="attached-object-row__icon"
                      :class="obj.colorClass"
                    />
                    <span class="attached-object-row__text">{{ obj.text }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="vx-row" v-if="canAttachApartment && isBuildingSelected">
                <div class="vx-col w-full">
                  <div class="act-info__param-row">
                    <label class="act-info__param-label">Помещение</label>
                    <div class="act-info__param-form-control">
                      <elsa-v-select
                        :options="apartments"
                        v-model="actData.apartment"
                        :getOptionLabel="(item) => `${item.number} (Л/С: ${item.account_number})`"
                        :reduce="item => item.id"
                        :clearable="false"
                        :disabled="!canActEdit"
                        @input="setApartment($event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="canAttachObject && isBuildingSelected">
                <div class="vx-row" v-if="attachObjectType.type === 'device'">
                  <div class="vx-col w-full">
                    <div class="act-info__param-row">
                      <label class="act-info__param-label">{{ attachObjectType.name }}</label>
                      <div class="act-info__param-form-control">
                        <elsa-v-select
                          :options="objectParams"
                          v-model="actData.object"
                          :getOptionLabel="(item) => `${$store.getters['common/devices/typeById'](item.type).name} (${item.factory_number ? item.factory_number : 'Без номера'})`"
                          :reduce="item => item.id"
                          :clearable="false"
                          :disabled="!canActEdit"
                          @input="setObject($event, 'device')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>


            <template v-if="selectedActType.id && !isParamsDisabled">
              <vs-divider><span class="font-medium">ИНФОРМАЦИЯ</span></vs-divider>

              <div class="vx-row">
                <div class="vx-col w-full act-header-info">
                  * - Поля обязательны для заполнения при применении акта
                </div>
              </div>

              <div class="vx-row" v-for="(param, paramIndex) in selectedActType.parameters" :key="paramIndex">
                <div class="vx-col w-full">
                  <div class="act-info__param-row" :class="{'block': param.type === 'table'}">
                    <label
                      class="act-info__param-label"
                      :class="{'text-danger': $v['actData.parameters'][param.field_name].$anyError}"
                    >
                      {{ [true, 'true'].includes(param.required) ? '*' : '' }}{{ param.p_name }}
                    </label>
                    <template v-if="['int', 'text', 'double'].includes(param.type)">
                      <act-input
                        class="act-info__param-form-control act-info__param-form-control_input"
                        v-model="actData.parameters[param.field_name]"
                        :disabled="!canActEdit"
                        :type="param.type"
                        :validator="$v['actData.parameters'][param.field_name]"
                      />
                    </template>
                    <template v-else-if="param.type === 'select'">
                      <div class="act-info__param-form-control">
                        <elsa-v-select
                          :options="convertArrayOptionsForSelect(param.values)"
                          v-model="actData.parameters[param.field_name]"
                          label="value"
                          :reduce="item => item.id"
                          :clearable="false"
                          :disabled="!canActEdit"
                          :danger="$v['actData.parameters'][param.field_name].$error"
                        />
                      </div>
                    </template>
                    <template v-else-if="param.type === 'bool'">
                      <act-checkbox
                        v-model="actData.parameters[param.field_name]"
                        dangerText="Выберите одно из значений"
                        :danger="$v['actData.parameters'][param.field_name].$anyError"
                        :disabled="!canActEdit"
                      />
                      <!--                      <vs-checkbox color="success" v-model="actData.parameters[param.field_name]" :disabled="!canActEdit" class="act-checkbox"/>-->
                    </template>
                    <template v-else-if="['date'].includes(param.type)">
                      <act-datepicker
                        class="act-info__param-form-control act-info__param-form-control_date"
                        :min="param.min_val"
                        :max="param.max_val"
                        :validator="$v['actData.parameters'][param.field_name]"
                        v-model="actData.parameters[param.field_name]" :type="param.type"
                        :disabled="!canActEdit"
                      />
                    </template>
                    <div class="acts-params-table" v-else-if="param.type === 'table'">
                      <table class="acts-params-table__table">
                        <thead>
                        <tr>
                          <th
                            v-for="(field, indexField) in param.table_fields" :key="indexField"
                            class="acts-params-table__table-th"
                          >
                            {{ field.p_name }}{{ [true, 'true'].includes(field.required) ? '*' : '' }}
                          </th>
                          <th style="width: 1%" v-if="canActEdit" class="acts-params-table__table-th">
                            <a
                              href="#" class="acts-params-table__add"
                              @click.prevent="!isParamsDisabled ? actData.parameters[param.field_name].push(Object.assign({}, param.newRow)) : () => {}"
                            >
                              <feather-icon icon="PlusIcon" />
                            </a>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          v-for="(tableParam, tableParamIndex) in  actData.parameters[param.field_name]"
                          :key="tableParamIndex"
                        >
                          <td
                            v-for="(field, indexField) in param.table_fields" :key="indexField"
                            class="acts-params-table__table-td"
                          >
                            <template v-if="isMultipleValueInput(actData, param, field, tableParam)">
                              <div class="flex">
                                <act-input
                                  inputClass="acts-params-table__form-control acts-params-table__form-control_input"
                                  :value="getDeviceStartValue(tableParam[field.field_name], 0)"
                                  @input="tableParam[field.field_name] = setDeviceStartValue(tableParam[field.field_name], 0, $event, deviceInputCount(tableParam))"
                                  :disabled="!canActEdit"
                                  :type="field.type"
                                  v-if="isDeviceHasDayInput(actData, param, field, tableParam)"
                                  class="flex-1 multiple-electricity-control"
                                  :placeholder="tableParam['device_type'] === 3 ? '' : 'День'"
                                  style="width: 40px!important"
                                  :class="{'acts-params-table__form-control_br': isDeviceHasNightInput(actData, param, field, tableParam) }"
                                />
                                <act-input
                                  inputClass="acts-params-table__form-control acts-params-table__form-control_input"
                                  :value="getDeviceStartValue(tableParam[field.field_name], 1)"
                                  @input="tableParam[field.field_name] = setDeviceStartValue(tableParam[field.field_name], 1, $event, deviceInputCount(tableParam))"
                                  :disabled="!canActEdit"
                                  :type="field.type"
                                  v-if="isDeviceHasNightInput(actData, param, field, tableParam)"
                                  class="flex-1 multiple-electricity-control"
                                  placeholder="Ночь"
                                  style="width: 40px!important"
                                  :class="{'acts-params-table__form-control_br': isDeviceHasPeakInput(actData, param, field, tableParam)}"
                                />
                                <act-input
                                  inputClass="acts-params-table__form-control acts-params-table__form-control_input"
                                  :value="getDeviceStartValue(tableParam[field.field_name], 2)"
                                  @input="tableParam[field.field_name] = setDeviceStartValue(tableParam[field.field_name], 2, $event, deviceInputCount(tableParam))"
                                  :disabled="!canActEdit"
                                  :type="field.type"
                                  v-if="isDeviceHasPeakInput(actData, param, field, tableParam)"
                                  class="flex-1 multiple-electricity-control"
                                  style="width: 40px!important"
                                  placeholder="Пик"
                                />
                              </div>
                            </template>
                            <template v-else-if="['int', 'text', 'double'].includes(field.type)">
                              <act-input
                                inputClass="acts-params-table__form-control acts-params-table__form-control_input"
                                v-model="tableParam[field.field_name]"
                                :disabled="!canActEdit"
                                :type="field.type"
                                :validator="$v['actData.parameters'][param.field_name].$each[tableParamIndex][field.field_name]"
                              />
                            </template>
                            <template v-else-if="field.type === 'select' || field.type === 'db_select'">
                              <div class="acts-params-table__form-control">
                                <elsa-v-select
                                  :options="convertObjectOptionsForSelect(field.values)"
                                  v-model="tableParam[field.field_name]"
                                  label="value"
                                  :reduce="item => item.id"
                                  :clearable="false"
                                  :disabled="!canActEdit"
                                  :danger="$v['actData.parameters'][param.field_name].$each[tableParamIndex][field.field_name].$error"
                                  :appendToBody="true"
                                  :test="field"
                                />
                              </div>
                            </template>
                            <template v-else-if="field.type === 'bool'">
                              <div style="display: flex; align-items: center; justify-content: center">
                                <act-checkbox
                                  v-model="tableParam[field.field_name]"
                                  dangerText="Выберите одно из значений"
                                  :danger="$v['actData.parameters'][param.field_name].$each[tableParamIndex][field.field_name].$anyError"
                                  :disabled="!canActEdit"
                                />
                              </div>
                            </template>
                            <template v-else-if="['date'].includes(field.type)">
                              <act-datepicker
                                class="acts-params-table__form-control acts-params-table__form-control_date"
                                v-model="tableParam[field.field_name]"
                                :type="param.type"
                                :disabled="!canActEdit"
                                :min="field.min_val"
                                :max="field.max_val"
                              />
                            </template>
                          </td>
                          <td class="acts-params-table__table-td" v-if="canActEdit">
                            <vs-button
                              @click="deleteRowFromTable(param.field_name, tableParamIndex)"
                              icon-pack="feather" icon="icon-trash" color="danger" type="border"
                              class="acts-params-table__table-row-delete" :disabled="isParamsDisabled"
                            />
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div>
                  <label class="act-info__param-label">Комментарий</label>
                  <vs-textarea
                    v-model="actData.main.comment" :disabled="!canActEdit"
                    class="act-info__param-form-control act-info__param-form-control_textarea"
                    :class="{'act-info__param-form-control_textarea-disabled': !canActEdit}"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <div key="loading__overlay" class="loading__overlay" v-else>
          Загрузка
        </div>
      </transition-group>
    </popup>
  </div>
</template>

<script>
import Popup                   from "@/components/popup/Popup";
import UploadedFileBlock       from "@/components/calculated-program/acts/UploadedFileBlock";
import 'swiper/dist/css/swiper.min.css';
import actTypes                from "@/dictionaries/actTypes";
import ActStatus               from "@/components/ActStatus";
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import 'viewerjs/dist/viewer.css';
import Viewer                  from 'v-viewer';
import Vue                     from 'vue';

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 999999999,
  },
});
Viewer.setDefaults({
  zIndexInline: 2017,
  zIndex:       9999999,
});

const IAMGES_CAN_VIEW = [
  'jpg',
  'jpeg',
  'png',
  'gif',
];

import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

import { required, integer, decimal, maxValue, minValue } from "vuelidate/lib/validators";
import ActInput                                           from "./popup/Input";
import ActDatepicker                                      from "./popup/Datepicker";
import ActCheckbox                                        from "@/components/calculated-program/acts/popup/Checkbox";
import vuelidateErrorExtractor                            from 'vuelidate-error-extractor';

Vue.use(vuelidateErrorExtractor, {
  template: ActInput,
  messages: {
    required: 'Поле обязательно для заполнения',
    decimal:  "Введите корректное число",
    integer:  "Введите корректное число",
    minValue: 'Минимальное значение для данного поля: {min}',
    maxValue: 'Максимальное значение для данного поля: {max}',
  },
});


export default {
  name:       "ActPopup_",
  components: {
    ActStatus,
    Popup,
    swiper,
    swiperSlide,
    UploadedFileBlock,
    ActInput,
    ActDatepicker,
    ActCheckbox,
  },
  props:      {
    active: {
      type:    Boolean,
      default: false,
    },
    act:    {},
  },
  validations() {
    return {
      'electricityParams': {
        ee1: { required },
        ee2: { required },
        ee3: { required },
      },

      'actData.parameters': this.parametersRules,
      'actData.main':       {
        act_type:     { required },
        buildings_id: { required },
      },
    };
  },
  data() {
    return {
      swiperOption:        {
        direction:     'vertical',
        slidesPerView: 5.2,
        spaceBetween:  10,
        pagination:    {
          el:        '.swiper-pagination-v',
          clickable: true,
        },
        breakpoints:   {
          1500: {
            slidesPerView: 4.2,
          },
          1000: {
            slidesPerView: 3.2,
          },
        },
      },
      $viewer:             null,
      isBuildingSelected:  false,
      isApartmentSelected: false,
      isObjectSelected:    false,
      apartments:          [],
      objectParams:        [],
      localActTypes:       [],
      actData:             {},
      isLoading:           false,
      viewImages:          [],
      showImagesViewer:    false,
      viewerHidden:        false,
      filesEmptyError:     false,
      parametersRules:     {},
      actTypeEntityFilter: null,
    };
  },
  computed: {
    activeX: {
      get() {
        return this.active;
      },
      set( value ) {
        this.$emit('update:active', value);
      },
    },
    buildings() {
      return this.$store.getters['appUser/houses'];
    },
    selectedActType() {
      if (this.actData.main.act_type === null) return {};
      return this.localActTypes.find(type => type.id === this.actData.main.act_type) || {};
    },
    canAttachApartment() {
      let can = false;
      if (this.selectedActType.hasOwnProperty('entity_types')) {
        let entityTypes = this.selectedActType.entity_types.split(',').map(type => type.trim().toLowerCase());
        can = entityTypes.includes('apartment');
      }
      return can;
    },
    canAttachObject() {
      let can = false;
      if (this.selectedActType.hasOwnProperty('entity_types')) {
        let entityTypes = this.selectedActType.entity_types.split(',');
        can = entityTypes.length === 3 || (entityTypes.length === 2 && entityTypes[1] !== 'apartment');
      } else {

      }

      return can;
    },
    attachObjectType() {
      let objectLabels = {
        device: 'Прибор учета',
      };
      let type = {};
      if (this.selectedActType.hasOwnProperty('entity_types')) {
        let entityTypes = this.selectedActType.entity_types.split(',').map(type => type.trim().toLowerCase());
        if (entityTypes.length === 3) {
          type = {
            type: entityTypes[2],
            name: objectLabels[entityTypes[2]] || 'Объект',
          };
        } else if (entityTypes.length === 2 && entityTypes[1] !== 'apartment') {
          type = {
            type: entityTypes[1],
            name: objectLabels[entityTypes[1]] || 'Объект',
          };
        }
      }
      return type;
    },
    isParamsDisabled() {
      return this.actData.main.entity_type === null || this.actData.main.entity_id === null;
    },
    canActEdit() {
      let statusDone = [4, 5].includes(this.actData.main.status);
      let statusNew = this.actData.main.status === null;
      let canCreate = this.$can('rp.acts.create', 'write');
      let canUpdate = this.$can('rp.acts.update', 'write');
      let con1 = !statusDone && !statusNew && canUpdate;
      let con2 = !statusDone && statusNew && canCreate;
      return con1 || con2;
    },
    popupStyles() {
      let windowWidth = this.$store.state.windowWidth;

      let sidebarWidth = this.showImagesViewer ? 'calc(25vw + 260px)' : '260px';
      let contentMargin = this.showImagesViewer ? 'calc(25vw + 275px)' : '275px';
      let popupWidth = '100%';

      if (!this.showImagesViewer) {
        if (windowWidth < 1200) {
          popupWidth = '100%';
        } else if (windowWidth < 1500) {
          popupWidth = 'calc(100vw - 260px)';
        } else {
          popupWidth = 'calc(75vw - 260px)';
        }
      }

      return {
        sidebarWidth,
        contentMargin,
        popupWidth,
      };
    },
    'actData.parameters'() {
      return this.actData.parameters;
    },
    'actData.main'() {
      return this.actData.main;
    },
  },
  methods:  {
    isMultipleValueInput( actData, param, field, tableParam ) {
      if (field.field_name === 'last_value' && tableParam.old_device_id && tableParam.old_device_id.split('||').length > 1) return true;

      if ([1, 2].includes(actData.main.act_type)
        && param.field_name === 'devices'
        && field.field_name === 'start_value'
        && [3, 4, 5].includes(+tableParam['device_type'])
      ) return true;

      if ([6, 7].includes(actData.main.act_type)
        && param.field_name === 'devices'
        && field.field_name === 'real_value'
        && tableParam['device_id']
        && typeof tableParam['device_id'] === 'string'
        && tableParam['device_id'].includes('||')
      ) return true;

      return false;
    },
    isDeviceHasDayInput( actData, param, field, tableParam ) {
      if (field.field_name === 'last_value') return true;
      if (tableParam['device_type'] >= 3) return true;
      if (tableParam['device_id']) return true;
      return false;
    },
    isDeviceHasNightInput( actData, param, field, tableParam ) {
      if (field.field_name === 'last_value' && tableParam.old_device_id) return tableParam.old_device_id.split('||').length > 1;
      if (tableParam['device_type'] >= 4) return true;
      if (tableParam['device_id'] && tableParam['device_id'].split('||').length >= 2) return true;
      return false;
    },
    isDeviceHasPeakInput( actData, param, field, tableParam ) {
      if (field.field_name === 'last_value' && tableParam.old_device_id) return tableParam.old_device_id.split('||').length > 2;
      if (tableParam['device_type'] >= 5) return true;
      if (tableParam['device_id'] && tableParam['device_id'].split('||').length >= 3) return true;
      return false;
    },
    deviceInputCount( tableParam ) {
      if (tableParam['device_type']) return tableParam['device_type'] - 2;
      if (tableParam['device_id']) return tableParam['device_id'].split('||').length;
      return null;
    },

    getDeviceStartValue( param, index ) {
      if (param === null) {
        return null;
      }
      if (typeof param === typeof 0) {
        return param;
      } else {
        let paramSplit = param.split("||");

        if (paramSplit.length - 1 >= index) {
          return Number(paramSplit[index]);
        } else {
          return null;
        }
      }
    },
    setDeviceStartValue( param, index, value, max ) {
      if (param === null) {
        param = [];
        for (let i = 1; i <= max; i++) {
          param.push(0);
        }
        param = param.join('||');
      }

      let paramSplit = param.split("||");
      paramSplit[index] = value;
      param = paramSplit.join("||");

      return param;
    },
    inited( viewer ) {
      this.$viewer = viewer;
    },
    resetAct() {
      this.actData = {
        entity_id:         null,
        entity_type:       null,
        main:              {
          errors:   null,
          act_type: null,
          status:   null,
          comment:  "",
        },
        building:          null,
        apartment:         null,
        object:            null,
        parameters:        [],
        files:             {
          uploaded:    [],
          deleted:     [],
          fromStorage: [],
        },
        deletedTableLines: {},
      };
      this.parametersRules = {};
      this.filesEmptyError = false;
      this.actTypeEntityFilter = null;
    },
    setActType( type ) {
      this.actData.main.act_type = type;
    },
    setBuilding( buildingId, loadObjectParams = true, changeEntity = true ) {
      return new Promise(async resolve => {
        try {
          this.actData.main.buildings_id = buildingId;

          if (changeEntity) {
            this.setEntity('building', buildingId);
          }

          this.$set(this.actData.main, 'apartment', null);
          this.$set(this.actData.main, 'object', null);
          let { data } = await this.$http.get('all_aparts', {
            params: {
              buildings_id: buildingId,
            },
          });

          this.apartments = data;

          if (loadObjectParams) {
            if (this.attachObjectType.type === 'device') {
              this.objectParams = await this.getObjectParams('devices', {
                buildings_id: this.actData.main.buildings_id,
                general:      true,
              });
            }
          }
          this.$set(this.actData, 'apartment', null);
          resolve();
        } catch (e) {
          console.error(e);
          this.apartments = [];
          resolve();
        } finally {
          this.isBuildingSelected = true;
        }
      });
    },
    setApartment( apartment ) {
      return new Promise(async resolve => {
        try {
          this.setEntity('apartment', (apartment && apartment.id) ? apartment.id : apartment);

          this.$set(this.actData, 'apartment', apartment);
          this.$set(this.actData, 'object', null);

          // if(this.attachObjectType.type === 'device'){
          this.objectParams = await this.getObjectParams('devices', {
            buildings_id:   this.actData.main.buildings_id,
            account_number: this.actData.apartment.account_number,
          });
          // }

          resolve();
        } catch (e) {
          console.error(e);
          this.objectParams = [];
          resolve();
        } finally {
          this.isApartmentSelected = true;
        }
      });
    },
    setObject( objectId, objectType, changeEntity = true ) {
      console.log('setObject', objectId, objectType, changeEntity);
      this.actData.object = objectId;
      this.isObjectSelected = true;

      if (changeEntity) {
        this.setEntity(objectType, objectId);
      }
    },
    setEntity( type, id ) {
      this.actData.entity_type = type;
      this.actData.entity_id = id;
    },
    saveAct( isFinal = false ) {
      this.setActParams(this.actData.parameters, isFinal);

      this.$v['actData.main'].$touch();
      this.$v['actData.parameters'].$touch();

      let reject = false;

      if (this.$v['actData.main'].$pending || this.$v['actData.main'].$error) {
        reject = true;
      }
      if (this.$v['actData.parameters'].$pending || this.$v['actData.parameters'].$error) {
        reject = true;
      }
      if (['true', true].includes(this.selectedActType.file_required) && (this.actData.files.uploaded.length + this.actData.files.fromStorage.length === 0)) {
        this.filesEmptyError = true;
        reject = true;
      }
      if (reject) {
        return false;
      }
      this.$emit('save', {
        act:     this.actData,
        isFinal: isFinal,
      });
    },
    handleFileUploads() {
      let files = this.$refs.files.files;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        this.actData.files.uploaded.unshift(file);
      }
      if (this.actData.files.uploaded) {
        this.filesEmptyError = false;
      }
    },
    deleteFile( typeFile, index ) {
      if (typeFile === 'uploaded') {
        this.actData.files.uploaded.splice(index, 1);
      } else if (typeFile === 'fromStorage') {
        this.actData.files.deleted.push(this.actData.files.fromStorage[index].id);
        this.actData.files.fromStorage.splice(index, 1);
      }
    },
    async updateDbSelectParams( with_old = false ) {
      let params = this.selectedActType.parameters;
      if (params) {
        for (let p = 0; p < params.length; p++) {
          let param = params[p];

          if (param.type === 'table') {
            for (let tf = 0; tf < param.table_fields.length; tf++) {
              let tableField = param.table_fields[tf];
              if (tableField.type === 'db_select') {
                let dbParams = await this.getDbParams(tableField.select_params, with_old, this.actData.main.act_type === 1 && tableField.field_name === "old_device_id");
                this.$set(tableField, 'values', dbParams);
              }
            }
          } else if (param === 'db_select') {
            let dbParams = await this.getDbParams(param.select_params, with_old);
            this.$set(param, 'values', dbParams);
          }
        }
      }
    },
    getDbParams( params, with_old = false, multipleElectricity = false ) {
      return new Promise(async resolve => {
        if (!this.actData.main.buildings_id) resolve([]);
        try {
          console.log(this.actData.entity_type, this.actData.entity_id);
          let { data } = await this.$http.get(params.url, {
            params: {
              buildings_id: this.actData.main.buildings_id,
              entity_type:  this.actData.entity_type,
              entity_id:    this.actData.entity_id,
              with_old:     with_old,
            },
          });
          let dbParams = {};

          if (multipleElectricity) {
            data
              .filter(d => !d.type.toLowerCase().startsWith('ээ'))
              .forEach(d => {
                let label = [];
                params.output_fields.forEach(outField => {
                  label.push(d[outField]);
                });
                dbParams[d[params.return_field]] = label.join(params.separator);
              });

            let ids = data
              .filter(d => d.type.toLowerCase().startsWith('ээ'))
              .map(d => d.id);
            if (ids.length) {
              dbParams[ids.join("||")] = "Электричество";
            }
          } else {
            data.forEach(d => {
              let label = [];
              params.output_fields.forEach(outField => {
                label.push(d[outField]);
              });
              dbParams[d[params.return_field]] = label.join(params.separator);
            });
          }
          resolve(dbParams);
        } catch (e) {
          console.error(e);
          resolve([]);
        }
      });
    },
    setActParams( dbParams, withRequired = false ) {
      this.parametersRules = {};
      const getRule = ( field ) => {
        let rule = {};
        if ([true, 'true'].includes(field.required) && withRequired) {
          rule.required = required;
        }

        if (field.field_name === 'start_value' || field.field_name === 'real_value' || field.field_name === 'last_value') {
          return rule;
        }

        if (['double', 'int'].includes(field.type)) {
          if (field.type === 'int') {
            // rule.integer = integer;
          } else {
            rule.decimal = decimal;
          }
          if (field.min_val !== undefined) {
            rule.minValue = minValue(field.min_val);
          }

          if (field.max_val !== undefined) {
            rule.maxValue = maxValue(field.max_val);
          }
        }
        return rule;
      };

      dbParams = dbParams || {};
      let params = this.selectedActType.parameters;
      let actParams = {};
      if (params) {
        params.forEach(param => {
          let value = dbParams[param.field_name];

          if (value === 'true') {
            value = true;
          }

          if (value === 'false') {
            value = false;
          }

          if (param.type === 'table') {
            let row = {
              isNew: true,
            };
            let tableRule = {
              $each: {},
            };
            if (withRequired && ['true', true].includes(param.required)) {
              tableRule.required = required;
            }
            this.parametersRules[param.field_name] = tableRule;
            param.table_fields.forEach(tableField => {
              row[tableField.field_name] = null;
              let rule = getRule(tableField);
              this.parametersRules[param.field_name].$each[tableField.field_name] = rule;
            });
            this.$set(param, 'newRow', row);
            actParams[param.field_name] = value || [];
          } else if (param.type === 'bool') {
            let rule = getRule(param);
            actParams[param.field_name] = value === false ? false : true === value ? true : null;
            this.parametersRules[param.field_name] = rule;
          } else {
            let rule = getRule(param);
            actParams[param.field_name] = value === undefined ? null : value;
            this.parametersRules[param.field_name] = rule;
          }
        });
      }
      this.actData.parameters = actParams;
    },
    async setAct( act ) {
      console.log(act);
      this.resetAct();
      Object.assign(this.actData.main, act.main);
      this.$set(this.actData, 'id', act.id);
      console.log('canActEdit', this.canActEdit);
      if (!this.canActEdit) {
        this.$set(this.actData, 'objects', act.objects);

        await this.setBuilding(act.main.buildings_id);

        if (act.apartment && act.apartment.length) {
          let apartment = this.apartments.find(a => a.account_number === act.apartment[0].account_number);
          if (apartment) {
            await this.setApartment(apartment);
          }
        }
      } else {
        let buildingLoadObjectParams = true;
        if (['apartment', 'device'].includes(act.entity_type)) {
          buildingLoadObjectParams = false;
        }
        await this.setBuilding(act.main.buildings_id, buildingLoadObjectParams);
        if (act.entity_type === 'apartment') {
          let apartment = this.apartments.find(a => a.id === act.apartment.id);

          if (apartment) {
            this.setApartment(apartment);
          }
        } else if (act.entity_type === 'device') {
          let apartment = this.apartments.find(a => a.account_number === act.device.account_number);
          await this.setApartment(apartment);
          let device = this.objectParams.find(p => p.id === act.device.id);
          this.setObject(device.id, 'device');
        }
      }

      this.setActHistory(this.actData.history);

      Object.assign(this.actData.files, act.files);
      this.$nextTick(() => {
        this.setActParams(act.parameters);
        this.updateDbSelectParams(true);
      });
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
    setActHistory( history ) {
    },
    getObjectParams( url, params ) {
      return new Promise(async resolve => {
        try {
          let { data } = await this.$http.get(url, { params: params });
          resolve(data);
        } catch (e) {
          console.error(e);
          resolve([]);
        }
      });
    },
    async updateViewImages() {
      let images = [];

      let canView = ( file ) => {
        let paths = file.name.split('.');
        return IAMGES_CAN_VIEW.includes((paths.pop()).toLowerCase());
      };

      let getImageFromFile = ( file ) => {
        return new Promise(resolve => {
          const fileReader = new FileReader();
          fileReader.onload = () => resolve(fileReader.result);
          fileReader.readAsDataURL(file);
        });
      };

      for await (let file of this.actData.files.uploaded) {
        if (canView(file)) {
          let img = await getImageFromFile(file);
          images.push(img);
        }
      }

      this.actData.files.fromStorage.forEach(file => {
        if (canView(file)) {
          images.push(this.$options.filters.imgPath(file.path));
        }
      });

      this.viewImages = images;

      if (!images.length && this.$refs.imagesViewer) {
        let backdrop = this.$refs.imagesViewer.querySelector('.viewer-backdrop');

        if (backdrop) {
          backdrop.remove();
        }
      }
    },
    deleteRowFromTable( field, index ) {
      if (this.actData.parameters[field][index].isNew !== true) {
        if (!this.actData.deletedTableLines.hasOwnProperty(field)) {
          this.$set(this.actData.deletedTableLines, field, []);
        }
        this.actData.deletedTableLines[field].push(index);
      }
      this.actData.parameters[field].splice(index, 1);
    },
    deleteAct( recreate = false ) {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       recreate ? 'Вы уверены что хотите откатить изменения акта?' : 'Вы уверены что хотите удалить акт?',
        acceptText: recreate ? 'Откатить' : 'Удалить',
        cancelText: 'Отменить',
        accept:     () => {
          this.$emit('delete', { id: this.actData.id, recreate: recreate });
        },
      });
    },
    checkDoubleValues( fieldName ) {
      if ([1, 6].includes(this.actData.main.act_type)) {
        if (this.actData.main.act_type === 1 && fieldName === 'old_device_id') {
          return true;
        } else if (this.actData.main.act_type === 6 && fieldName === 'device_id') {
          return true;
        }
      }
      return false;
    },
    convertArrayOptionsForSelect( options ) {
      return options.map(( value, id ) => ({ id, value }));
    },
    convertObjectOptionsForSelect( options ) {
      const result = [];
      for (let id in options) {
        result.push({ id, value: options[id] });
      }
      return result;
    },
    loadActTypes() {
      actTypes.getList().then(list => this.localActTypes = list);
    },
  },
  created() {
    this.resetAct();
    this.loadActTypes();
  },
  watch: {
    // activeX() {
    //   console.log({ activeX: this.activeX });
    //   if (this.activeX) {
    //     this.localActTypes = JSON.parse(JSON.stringify(this.actTypes));
    //   }
    // },
    'actData.main.act_type'() {
      this.setActParams();
      this.updateDbSelectParams();
    },
    'actData.entity_id'() {
      this.updateDbSelectParams();
    },
    'actData.files': {
      deep: true,
      handler() {
        this.updateViewImages();
      },
    },
    showImagesViewer() {
      if (this.showImagesViewer) {
        this.viewerHidden = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.viewerHidden = false;
          }, 300);
        });
      }
    },
  },
};
</script>

<style lang="scss">

.file-empty-error {
  line-height: 1.2;
  font-size: .7rem;
  width: 100%;
  text-transform: uppercase;
  color: rgba(var(--vs-danger), 1);
  margin: 5px 0;
  text-align: center;
}

.act-info {
  &__files {
    position: fixed;
    top: 56px;
    bottom: 15px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-right: 15px;
    border-right: 1px solid rgba(0, 0, 0, .1);
    transition: width .3s ease-in;
    z-index: 1;

    &-viewer {
      height: 100%;
      margin-left: 15px;
    }
  }

  &-table-add.small {
    width: 20px !important;
    height: 20px !important;
    padding: 0;

    i {
      font-size: 1rem;
      width: 20px;
      height: 20px;
      display: block;
      line-height: 20px;
    }
  }

  &__main-info {
    transition: margin .3s ease-in;
  }

  @media (min-width: 1600px) {
    $viewerWidth: 30vw;

    &__files {
      width: calc(#{$viewerWidth} + 260px);
    }

    &__main-info {
      margin-left: calc(#{$viewerWidth} + 275px)
    }
  }

  &__section-header {
    flex: 0;
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 500;

    &_flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }

  &__section-body {
    flex: 1;
    height: calc(100% - 33px);
  }

  &__file {
    background: #f4f4f4;
    width: 230px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    margin: 0 auto;

    &-view-overlay {
      position: absolute;
      background: rgba(0, 0, 0, .5);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: none;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &-view-icon {
      width: 30px;
      height: 30px;
      color: #fff;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &-delete {
      display: none;
      position: absolute !important;
      right: 5px;
      top: 5px;
      width: 20px;
      height: 20px;
      padding: 2px;
      border: 1px solid rgba(var(--vs-danger), 1);
      color: #fff;
      background: rgba(var(--vs-danger), 1);
      border-radius: 2px;
      cursor: pointer;
      z-index: 1;
    }

    &:hover {
      .act-info__file {
        &-delete {
          display: inline-flex;
        }

        &-view-overlay {
          display: flex;
        }
      }
    }

    &-icon {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &-ext {
      font-size: 1.1rem;
      line-height: 1.2;
      text-align: center;
      font-weight: 500;
    }
  }

  &__param-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  &__param-label {
    padding-right: 15px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
    flex: 1;
    margin-bottom: 5px;
    display: block;

  }

  &__param-form-control {
    flex: 2;
    margin-bottom: 5px;


    &_select {
      .con-select {
        width: 100%;
      }

      .vs-select--input {
        padding: .5rem 1rem;
        border-radius: 2px;
      }
    }

    &_input {
      .vs-input {
        width: 100%;
      }

      .vs-input--input {
        padding: .5rem 1rem;
        border-radius: 2px;
      }
    }

    &_date {
      input {
        width: 100%;
        padding: .5rem 1rem;
        border-radius: 2px;
      }
    }

    &_textarea {
      border-radius: 2px;

      &-disabled {
        opacity: .5;
      }
    }

    .vs__dropdown-toggle, .vs--open .vs__dropdown-toggle {
      border-radius: 2px;
    }

    .vs__selected-options {
      padding: 7px 0 7px 10px;
    }
  }

  .modal__body {
    height: 100vh;
  }
}

.acts-params-table {
  width: 100%;
  //padding-bottom: 200px;
  overflow-x: auto;
  overflow-y: visible;
  //margin-bottom: -195px;
  padding-bottom: 5px;

  &__table {
    border-collapse: collapse;

    &-th {
      line-height: 1.2;
      text-align: center;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      border: 1px solid rgba(0, 0, 0, .1);
    }

    &-td {
      border: 1px solid rgba(0, 0, 0, .1);
    }

    &-row-delete {
      border: none !important;
      width: 100% !important;
      height: 100% !important;
    }
  }

  &__form-control {

    &_br {
      border-right: 1px solid rgba(0, 0, 0, .1);
    }

    &_select {
      width: auto;

      .vs-select--input {
        padding: .5rem 1rem;
        border-radius: 0;
        border: 1px solid transparent;
      }

      & + .validation-input-error {
        text-transform: none;
      }
    }

    &_input {
      width: auto;

      .vs-input {
        width: auto;
      }

      & + .validation-input-error {
        text-transform: none;
      }

      .vs-input--input {
        padding: 0.5rem 1rem;
        border: 1px solid transparent !important;
        border-radius: 0;
        box-shadow: none !important;
      }

      &.input-icon-validate-danger {
        .vs-input--input {
          border: 1px solid rgba(var(--vs-danger), 1) !important;
        }
      }
    }

    &_date {

      & > div > div > input {
        padding: .5rem 1rem;
        border: 1px solid transparent;
        border-radius: 0;
        width: 100%;
      }
    }
  }

  &__add {
    display: block;
    color: rgba(var(--app-content-color), 1);
    line-height: 1;
    height: 20px;
    width: 20px;

    svg {
      width: 100%;
      height: 100%;
    }

    &:hover {
      color: rgba(var(--vs-success), 1);
    }
  }

  .vs__dropdown-toggle, .vs--open .vs__dropdown-toggle {
    border: 0;
  }
}

.act-file-uploader {
  position: relative;
  transition: .3s ease;

  &:hover {
    background: darken(#f4f4f4, 5%);
  }

  &__input {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    opacity: 0;
  }
}

.loading__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: rgba(0,0,0,.2); */
  z-index: 100;
  /* color: #fff; */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;

  &::after {
    content: ' .';
    animation: dots 2s steps(5, end) infinite;
  }

  @keyframes dots {
    0%, 20% {
      color: rgba(0, 0, 0, 0);
      text-shadow: .25em 0 0 rgba(0, 0, 0, 0),
      .5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
      color: rgba(var(--app-content-color), 1);
      text-shadow: .25em 0 0 rgba(0, 0, 0, 0),
      .5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
      text-shadow: .25em 0 0 rgba(var(--app-content-color), 1),
      .5em 0 0 rgba(0, 0, 0, 0);
    }
    80%, 100% {
      text-shadow: .25em 0 0 rgba(var(--app-content-color), 1),
      .5em 0 0 rgba(var(--app-content-color), 1);
    }
  }
}

.no-images-to-view {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-left: 1px solid rgba(0, 0, 0, .1);
  height: 100%;
}

.act-status {
  width: 250px;
  border-radius: 0;
  margin: 0;
}

.vs-switch_small {
  height: 18px;
  min-width: 34px;

  .vs-switch--circle {
    width: 14px;
    height: 14px;
  }

  &.vs-switch-active .vs-switch--circle {
    margin-left: calc(100% - 18px);
  }

}

.act-viewer-switch {
  display: flex;
  align-items: center;

  &__label {
    font-weight: 400;
    font-size: .7rem;
    text-transform: uppercase;
    line-height: 1.2;
  }
}

.validation-input {
  &.vs-input {

    .input-icon-validate.vs-input--icon-validate {
      display: none !important;
    }

    & > span {
      display: none !important;
    }
  }

  .input-select-con + span {
    display: none !important;
  }

  &-error {
    display: inline-block;
    color: rgba(var(--vs-danger), 1) !important;
    overflow: hidden;
    transition: all .25s ease;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    margin-top: 3px;
    font-weight: 500;
    text-transform: uppercase;
    padding: 4px;
    line-height: 1.2;
    font-size: .7rem;
    border-radius: 2px;
    z-index: 100;
    position: absolute;
    top: 100%;
    left: 0;
  }
}

.act-header-button {
  &_icon {
    width: 30px !important;
    height: 30px !important;
    padding: 0;
    border-radius: 2px;

    .vs-button--icon {
      font-size: 18px;
    }
  }

  & + & {
    margin-left: 10px;
  }
}

.act-header-buttons {
  display: flex;
  align-items: center;
}

.act-header-info {
  margin-top: -10px;
  margin-bottom: 20px;
  text-transform: uppercase;
  text-align: center;
  font-size: .8rem;
}

.act-checkbox {
  margin: 0 0 5px 0;

  .vs-checkbox {
    border-width: 1px !important;

  }
}

.con-vs-dialog {
  z-index: 999999;
}

.attached-object-row {
  display: flex;
  align-items: center;
  line-height: 1.2;
  font-size: .9rem;
  font-weight: 500;

  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}

.multiple-electricity-control {
  height: 32px !important;

  .act-input-placeholder {
    padding: 0;
    height: 100%;
    text-align: center;
    justify-content: center;
  }

  .acts-params-table__form-control_input,
  .vs-con-input-label .vs-con-input,
  .vs-input--input {
    padding: 0;
    height: 100%;
    text-align: center;
  }
}
</style>
